export enum AuthMode {
  Public = "public",
  Password = "password",
  Private = "private",
  Slack = "slack",
  Teams = "teams",
}
